<app-tab-form-modal i18n-header header="Shipping Details" [model$]="model$" (saveClicked)="save()">
  @if (outcome(); as outcome) {
    <p class="form-explanation" i18n>
      Despatch note {{ outcome.despatchNoteNo }} has been created for order {{ outcome.orderNo }}. Correct the shipping
      details, then save to book the shipping.
    </p>
    @for (error of errors(); track $index) {
      <app-alert [message]="error" type="warning"></app-alert>
    }
    @if (outcome.despatchNoteId; as despatchNoteId) {
      <app-shipper-interface
        [salesDespatchNoteId]="despatchNoteId"
        [shipperInterfaceHeaderId]="outcome.shipperInterfaceHeaderId"
        [showButtons]="false"
      ></app-shipper-interface>
    }
  }
</app-tab-form-modal>
